import PicklistMetadata from "../PicklistMetadata";

/**
 * Positions that can OWN a record in this app.
 *
 * A position carries a Focus Area, and it decides which app the position is a persona in: Foundation
 * positions act here, Data Catalog ones act in the Data Catalog. A record owned by a Data Catalog
 * position answers to nobody here -- its owner cannot wear that persona in this app, so the record
 * appears under no persona its owner could assume.
 *
 * A SEPARATE PICKLIST RATHER THAN A FILTER ON "Position". That one is shared with the Administration
 * components -- choosing a parent position, putting a user in a position, attaching a position to an
 * organization or a work group -- and every one of those must go on offering EVERY position, because
 * administering a Data Catalog position is a thing this app does. Narrowing the shared list would
 * have broken all of them to fix one.
 *
 * The mirror of t5's PositionShared, which restricts the same component to "Data Catalog".
 */
class PositionFoundationPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "PositionFoundation";
        this.bounded = true;
        this.enterpriseComponent = "Position";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.useRealm = false;
        // Consumed by PositionEnterpriseComponent.performQuery as an EQUAL QBE member. The tag is the
        // IDOC's "FocusArea", not the enterprise component's "Focus Area" -- the query is built from
        // the document, so the spaced spelling matches nothing and silently filters to zero rows.
        this.searchSpecification = {"FocusArea": "QMS"};
        this.sortSpecification = {
            "Name": "DESC",
        };
        this.static = false;
        this.typeField = "Name";
        this.typeValue = "USID";
        this.typeValue2 = null;
        this.visibilityType = null;
        this.allowNoSelection = false;
        this.allowNoSelectionValue = null;
        this.allowNoSelectionDisplayValue = null;
    }
}

export default PositionFoundationPicklistMetadata;
